export const PATH_NAMES = Object.freeze({
  PIERCING_TYPE: 'piercing-type',
  WELDING_TYPE: 'welding-type',
  SELECT_SHOP: 'shops',
  SELECT_DATE: 'select-date',
  ABOUT_YOU: 'about-you',
  REVIEW: 'review',
  BOOKING: 'bookings/:bookingId',
  COMPLETED_BOOKING: 'completed-booking',

  EDIT_SHOP: 'edit-shop',
  EDIT_DATE: 'edit-date',
  EDIT_YOUR_DETAILS: 'edit-your-details',
  EDIT_QUESTION_ANSWERS: 'edit-question-answers',
  EDIT_PIERCING_TYPE: 'edit-piercing-type',
});
